import React, { useState } from "react";
import { useForm, Controller, type SubmitHandler } from "react-hook-form";
import { ActionIcon, Button, Modal, Input, Text, Textarea } from "rizzui";
import { PiXLight } from "react-icons/pi";

export type Reject = {
    orderId: string;
    rejectedReason: string;
};

interface RejectModalProps {
    show: boolean;
    handleSave: (reject: Reject) => void;
    title: string;
    description?: string;
}

const RejectModal: React.FC<RejectModalProps> = ({
    show,
    title,
    description,
    handleSave,
}) => {
    const [modalState, setModalState] = useState(false);

    const { control, handleSubmit, reset } = useForm<Reject>({
        defaultValues: {
            orderId: "",
            rejectedReason: "",
        },
    });

    const onSubmit: SubmitHandler<Reject> = (data) => {
        handleSave(data);
        reset();
        setModalState(false);
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        void handleSubmit(onSubmit)(event);
    };

    return (
        <>
            <Button
                type="button"
                color="danger"
                variant="outline"
                onClick={() => setModalState(true)}
                disabled={show}
            >
                Reject Order
            </Button>
            <Modal isOpen={modalState} onClose={() => setModalState(false)}>
                <div className="m-auto px-7 pt-6 pb-8">
                    <div className="mb-7 flex items-center justify-between">
                        <div className="flex flex-col ">
                            <Text className="text-lg font-semibold h3">
                                {title}
                            </Text>
                            <p className="text-sm text-gray-500">
                                {description}
                            </p>
                        </div>
                        <ActionIcon
                            size="sm"
                            variant="text"
                            onClick={() => setModalState(false)}
                        >
                            <PiXLight
                                className="h-auto w-6"
                                strokeWidth={1.8}
                            />
                        </ActionIcon>
                    </div>
                    <form onSubmit={handleFormSubmit} noValidate>
                        <div className="mb-4 mt-2">
                            <Controller
                                name="rejectedReason"
                                control={control}
                                render={({ field }) => (
                                    <Textarea
                                        label="Rejection Reason"
                                        rows={3}
                                        {...field}
                                    />
                                )}
                            />
                        </div>
                        <div className="flex justify-end gap-4">
                            <Button
                                type="button"
                                variant="outline"
                                color="secondary"
                                onClick={() => setModalState(false)}
                            >
                                Cancel
                            </Button>
                            <Button type="submit">Reject Order</Button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
};

export { RejectModal };
